import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postNotificationsPublicIdRestore } from "Infrastructure/Api/Api";
import { notificationsKeys } from "Api/Queries/Notifications/useNotifications";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { toast } from "sonner";
import { Resources, useResource } from "Translations/Resources";
import { notificationKeys } from "Api/Queries/Notifications/useNotificationQuery";
import { allAdminNotificationsKeys } from "Api/Queries/Notifications/useAllNotifications";

const RESOURCES = Resources.Hooks.Notifications;

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useRestoreNotificationMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();
  const { t } = useResource();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails((publicId: string) =>
      postNotificationsPublicIdRestore(publicId),
    ),
    onSuccess: (_, publicID: string) => {
      queryClient.invalidateQueries({
        queryKey: notificationKeys.detail(publicID),
      });
      queryClient.invalidateQueries({ queryKey: notificationsKeys.all });
      queryClient.invalidateQueries({
        queryKey: allAdminNotificationsKeys.all,
      });
      toast.success(t(RESOURCES.Restored));
      onSuccess?.();
    },
    onError: (error) => {
      toast.error(t(RESOURCES.RestoreError));
      onError?.(error);
    },
  });
};
